import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-a-up",
  "use": "icon-a-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-up\" id=\"icon-a-up\"><line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"5\" /><polyline points=\"5 12 12 5 19 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol